import { render } from "./AddComplaints.vue?vue&type=template&id=8b47931a"
import script from "./AddComplaints.vue?vue&type=script&lang=js"
export * from "./AddComplaints.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__